import { commonStructure, readonlyStructure } from "./structure";
import { ui, setToolbarLabels, getToolbarText } from "./buttons";

function getText(text) {
	const locale = webix.i18n.spreadsheet;
	return locale.actions[text] || locale.labels[text] || text;
}

function calcButtons(){
	const groups = {
		"undo-redo": ["undo", "redo"],
		"insert": ["graph", "add-image", "add-comment", "controls"]
	};
	const result = {};

	for (let name in groups){
		result[name] = 0;
		for(let i = 0; i < groups[name].length; i++) {
			const width = webix.html.getTextSize(
				getText(groups[name][i]), 
				"webix_ssheet_button_measure"
			).width + 7;
			result[name] = Math.max(width, result[name]);
		}
	}
	return result;
}

function createButton(config, size){
	const button = {
		$button: config.id,
	};

	if (config.view) {
		button.view = config.view;
		button.name = config.id;
	}

	// check not to break complex labels of icon buttons and icon-selectors
	if (config.toolbarLabel) {
		button.label = getToolbarText(config.id);
	}

	button.tooltip = getToolbarText(config.id);

	if (config.submenu) button.options = setToolbarLabels(config.submenu);

	if (config.toolbarWidth) {
		const buttonHeight = webix.skin.$active.buttonHeight;
		button.width = size || (buttonHeight * config.toolbarWidth + (config.toolbarWidth - 1) * 2); // 2 is for margins between smaller items that are below / above the spanned item
	}
	return button;
}

// simple 1-row block with a sub-label
function createBlock(structure){
	return [
		{
			padding: 3,
			rows: [
				{
					margin: 2,
					cols: structure.submenu.map(createButton)
				},
				ui.title({ title: getToolbarText(structure.id) }),
			]
		},
		{view: "ssheet-separator"},
	];
}

function createRows(buttons, size){
	let sum = buttons.reduce((total, button) => total + (button.toolbarWidth || 1), 0);
	const res = {
		rows: [
			{ margin: 2, cols: [] },
			{ margin: 2, cols: [] }
		]
	};

	let last = 0;
	const rowSpans = [];
	for (let i = 0; i < buttons.length; i++){
		if (buttons[i].toolbarHeight) {
			rowSpans.push({ index: i, span: buttons[i].toolbarHeight });
			sum -= (buttons[i].toolbarWidth || 1);
			continue;
		}
		const button = createButton(buttons[i], size);
		const width = buttons[i].toolbarWidth || 1;
		const index = (last + width > Math.ceil(sum / 2)) ? 1 : 0;
		
		res.rows[index].cols.push(button);
		last += width;
	}

	if (rowSpans.length) {
		const wrap = {
			cols: [res]
		};
		rowSpans.forEach(r => {
			wrap.cols.splice(r.index, 0, createButton(buttons[r.index]));
		});
		return wrap;
	}

	return res;
}

// more complex block with cols and rows of buttons and a sub-label
function createGridBlock(structure, sizes){
	return [
		{
			padding: 3,
			margin: 0,
			rows: [
				createRows(structure.submenu, sizes[structure.id]),
				ui.title({ title: getToolbarText(structure.id) }),
			]
		},
		{view: "ssheet-separator"},
	];
}

const readonlyElements = () => {
	const arr = readonlyStructure.flatMap(s => createBlock(s));
	arr.push({});
	return arr;
};

export function getAllElements(readonly){
	const sizes = calcButtons();
	if (readonly) {
		return readonlyElements();
	}

	return commonStructure.flatMap(s => createGridBlock(s, sizes));
}